import React from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import DashboardPage from './DashboardPage';
const Dashboard = () => {
  return (
    <div className="flex" style={{ background: 'black' }}>
      <Sidebar></Sidebar>
      <DashboardPage />
    </div>
  );
};

export default Dashboard;
